<div class="main">
  <div class="section">
    <div class="request_call_main">
      <div class="modal_wrapper" id="modal_for_demo">
        <div class="close_modal">
          <img
            src="assets/popup_close_icon.svg"
            alt=""
            class="close_icon"
            (click)="closeModal()"
          />
        </div>
        <iframe
          class="modal_content"
          src="https://calendly.com/vinay-goyal/instavans-product-demo-discussion?month=2024-02"
        ></iframe>
      </div>
      <div
        class="overlay_modal"
        id="overlay_modal"
        (click)="closeModal()"
      ></div>
      <div class="left">
        <div class="background_black">
          <div class="bg_text">
            <div>
              <div>GET</div>
              <div>IN</div>
              <div>TOUCH</div>
            </div>
          </div>
        </div>

        <div>
          <div class="circle">
            <ng-lottie
              width="500px"
              height="400px"
              [options]="{
                path: path,
                renderer: 'svg',
                autoplay: true,
                loop: true
              }"
            ></ng-lottie>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="header">
          <img src="assets/instavans_logo.png" alt="" />
        </div>
        <div class="information_taking_box">
          <div class="information_header">
            Let’s talk! Schedule your call back now.
          </div>
          <div class="infomation" style="margin-top: 36px">
            <div class="info1">
              <div class="form_group call_back_select">
                <div class="did-floating-label-content">
                  <select
                    class="did-floating-select"
                    [(ngModel)]="formData.organization_type"
                    onclick="this.setAttribute('value', this.value);"
                    onchange="this.setAttribute('value', this.value);"
                    (change)="handleChange()"
                    value=""
                  >
                  <option value="Shipper">Shipper</option>
                  <option value="Carrier">Carrier</option>
                  <option value="4PL">4PL</option>
                  </select>
                  <label class="did-floating-label">Organization Type</label>
                </div>
              </div>
            </div>      
            <div class="info2">
              <div class="form_group">
                <input
                  id="text"
                  type="text"
                  [(ngModel)]="formData.company"
                  value=""
                  placeholder=" "
                />
                <label class="custom_label" for="text">Company</label>
              </div>
            </div>
          </div>
          <div class="infomation" *ngIf="formData.organization_type != 'Carrier'">
            <div class="info1">
              <div class="form_group call_back_select">
                <div class="did-floating-label-content">
                <select
                    class="did-floating-select "
                    [(ngModel)]="formData.functions"
                    onclick="this.setAttribute('value', this.value);"
                    onchange="this.setAttribute('value', this.value);"
                    value=""
                  >
                    <option value="Logistics">Logistics</option>
                    <option value="Operations">Operations</option>
                    <option value="Procurement">Procurement</option>
                    <option value="Finance">Finance</option>
                    <option value="Other">Other</option>
                  </select>
                <label class="did-floating-label">Function</label>
              </div>
              </div>
            </div>
            <div class="info2">
              <div class="form_group call_back_select">
                <div class="did-floating-label-content">
                <select
                    class="did-floating-select "
                    [(ngModel)]="formData.department"
                    onclick="this.setAttribute('value', this.value);"
                    onchange="this.setAttribute('value', this.value);"
                    value=""
                  >
                    <option value="Supply Chain">Supply Chain</option>
                    <option value="Transportation">Transportation</option>
                    <option value="Warehousing">Warehousing</option>
                    <option value="Distribution">Distribution</option>
                    <option value="Other">Other</option>
                  </select>
                <label class="did-floating-label">Department</label>
              </div>
              </div>
            </div>
          </div>
          <div class="infomation" *ngIf="formData.organization_type != 'Shipper'"> 
            <div class="info1">
              <div class="form_group call_back_select">
                <div class="did-floating-label-content">
                  <select
                    class="did-floating-select"
                    [(ngModel)]="formData.service_type"
                    onclick="this.setAttribute('value', this.value);"
                    onchange="this.setAttribute('value', this.value);"
                    value=""
                  >
                    <option value="Full Truckload (FTL)">Full Truckload (FTL)</option>
                    <option value="Less than Truckload (LTL)">Less than Truckload (LTL)</option>
                    <option value="Both">Both</option>
                  </select>
                  <label class="did-floating-label">Service Type</label>
                </div>
              </div>
            </div>
            <div class="info2">
              <div class="form_group call_back_select">
                <div class="did-floating-label-content">
                  <select
                    class="did-floating-select"
                    [(ngModel)]="formData.fleet_size"
                    onclick="this.setAttribute('value', this.value);"
                    onchange="this.setAttribute('value', this.value);"
                    value=""
                  >
                    <option value="Less than 100">Less than 10</option>
                    <option value="100 - 500">10 - 50</option>
                    <option value="500 - 1000">50 - 100</option>
                    <option value="More than 1000">More than 100</option>
                  </select>
                  <label class="did-floating-label">Fleet Size</label>
                </div>
              </div>
            </div>
          </div>
          <div class="infomation" *ngIf="formData.organization_type == 'Shipper'">
            <div class="info1">
              <div class="form_group call_back_select">
                <div class="did-floating-label-content">
                  <select
                    class="did-floating-select"
                    [(ngModel)]="formData.shipment_volume_per_month"
                    value=""
                    onclick="this.setAttribute('value', this.value);"
                    onchange="this.setAttribute('value', this.value);"
                  >
                    <option value="Less than 100">Less than 100</option>
                    <option value="100 - 500">100 - 500</option>
                    <option value="500 - 1000">500 - 1000</option>
                    <option value="More than 1000">More than 1000</option>
                  </select>
                  <label class="did-floating-label">Shipments Volumes/Month</label>
                </div>
              </div>
            </div>
           
            <div class="info2">
              <div class="form_group call_back_select">
                <div class="did-floating-label-content">
                  <select
                    class="did-floating-select"
                    [(ngModel)]="formData.industry"
                    value=""
                    onclick="this.setAttribute('value', this.value);"
                    onchange="this.setAttribute('value', this.value);"
                  >
                    <option value="Steel">Steel</option>
                    <option value="Chemicals">Chemicals</option>
                    <option value="Cement">Cement</option>
                    <option value="FMCG">FMCG</option>
                    <option value="Textiles">Textiles</option>
                    <option value="Electronics">Electronics</option>
                    <option value="Pharmaceuticals">Pharmaceuticals</option>
                    <option value="Others">Others</option>
                  </select>
                  <label class="did-floating-label">Industry</label>
                </div>
              </div>
            </div>
            
          </div>
        
          <div class="infomation">
            <div class="info1">
              <div class="form_group">
                <input
                  id="text"
                  type="text"
                  [(ngModel)]="formData.name"
                  value=""
                  placeholder=" "
                />
                <label class="custom_label" for="text">Name</label>
              </div>
            </div>
            <div class="info2">
              <div class="form_group">
                <input
                  id="text"
                  type="text"
                  [(ngModel)]="formData.official_email"
                  value=""
                  placeholder=" "
                />
                <label class="custom_label" for="text">Official Email</label>
              </div>
            </div>
          </div>
          <div class="infomation">
            <div class="info1">
              <div class="form_group">
                <input
                  id="text"
                  type="text"
                  style="width: 94%"
                  [(ngModel)]="formData.phone_no"
                  value=""
                  placeholder=" "
                />
                <label class="custom_label" for="text">Phone Number</label>
              </div>
            </div>
            <div class="info2">
              <div class="form_group">
                <input
                  id="text"
                  type="text"
                  [(ngModel)]="formData.city"
                  placeholder=" "
                />
                <label class="custom_label" for="text">City</label>
              </div>
            </div>
          </div>
         
          <div class="submit_request" (click)="requestCallback()">
            Book a Demo
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
